import React from 'react'
import type { User } from 'types/user'
import { getUserDisplayName } from '@disco/utils/string-utils'
import TextOverflow from 'components/ui/text-overflow'
import UserAvatar from 'components/ui/user-avatar'
import styles from './index.module.css'

type Props = {
  user: Partial<User>
}

/**
 * UserName component for displaying user information with avatar and name
 *
 * A functional component that displays a user's avatar and name in a compact format.
 * Uses text overflow handling for long names and provides consistent styling
 * for user representation across the application.
 *
 * @param props - Component props
 * @param props.user - User object containing user information
 * @returns JSX element containing the user's avatar and name display
 */
const UserName = ({ user }: Props) => {
  const name = getUserDisplayName(user)
  return (
    <div className={styles.userName}>
      <UserAvatar
        className={styles.userNameAvatar}
        name={name}
        size="24px"
        fontSize="11px"
      />
      <div className={styles.userNameCaption}>
        <TextOverflow content={name} />
      </div>
    </div>
  )
}

export default React.memo<Props>(UserName)
